/**
 * Dataset / IndexedDB às vezes guardam PRECO como mapa aninhado (ex.: `{ "12": { VLR_PRECO, FAIXAACRFINANCEIRO, ... } }`
 * ou `{ [COD_PRODUTO]: { [QTD_EMBALAGEM]: leaf } }`), não como array de linhas.
 * `Object.values` sozinho perde a quantidade na chave — `handlePrices` precisa de `QTD_EMBALAGEM` para casar EMBALAGEM.
 */
const isLikelyPriceLeaf = (v: unknown): v is Record<string, unknown> =>
  !!v &&
  typeof v === 'object' &&
  !Array.isArray(v) &&
  ((v as Record<string, unknown>).VLR_PRECO != null ||
    (v as Record<string, unknown>).VLR_PAUTA != null ||
    (v as Record<string, unknown>).COD_TRIBUTACAO_PRODUTO != null ||
    (v as Record<string, unknown>).DESTACA_ST != null ||
    (v as Record<string, unknown>).COD_PROMOCAO != null);

export function normalizePrecoListForCalc(raw: unknown): Record<string, unknown>[] {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw.filter((x): x is Record<string, unknown> => isLikelyPriceLeaf(x));
  }
  if (typeof raw !== 'object') return [];

  const rows: Record<string, unknown>[] = [];

  for (const [outerKey, outerVal] of Object.entries(raw)) {
    const outerNum = Number(outerKey);

    if (isLikelyPriceLeaf(outerVal)) {
      const v = outerVal;
      rows.push({
        ...v,
        ...(Number.isFinite(outerNum) && v.QTD_EMBALAGEM == null ? { QTD_EMBALAGEM: outerNum } : {}),
      });
      continue;
    }

    if (outerVal && typeof outerVal === 'object' && !Array.isArray(outerVal)) {
      for (const [innerKey, innerVal] of Object.entries(outerVal as object)) {
        const innerNum = Number(innerKey);
        if (isLikelyPriceLeaf(innerVal)) {
          const v = innerVal;
          rows.push({
            ...v,
            ...(Number.isFinite(innerNum) && v.QTD_EMBALAGEM == null ? { QTD_EMBALAGEM: innerNum } : {}),
          });
        }
      }
    }
  }

  return rows;
}
